import { setUserPropertiesPostHog } from '@/hooks/useAuth';

import appwriteService from '@/config/appwrite';

import { apiClient } from '../apiClients';
import { Endpoints } from '../../network';

export const checkAmazonOrderId = async (id: string) => {
  const response = await apiClient.get(`${Endpoints.checkAmazonOrderId}/${id}`);

  return response?.data;
};

export const syncAmazonOrderId = async (id: string) => {
  const response = await apiClient.post(`${Endpoints.syncAmazonOrderId}`, {
    order_id: id,
  });
  await appwriteService.updateOnboardingPrefs({ amazon_claim: true });
  await setUserPropertiesPostHog({ amazon_claim: true });
  return response?.data;
};
